import { Flex, Image, Link } from '@chakra-ui/react';
import { certikLink, hackenLink } from '../../constants/footerLinks';
import React from 'react';

export const PartnerLinks = React.memo(() => {
  return (
    <Flex gap="30px" alignItems={'center'}>
      <Link href={certikLink}>
        <Image src="/assets/CertikLogo.png" alt="CertikLogo" w={{ base: '90px', sm: '100px' }} h={'22px'} />
      </Link>
      <Link href={hackenLink}>
        <Image src="/assets/HackenLogo.png" alt="HackenLogo" w={{ base: '90px', sm: '100px' }} h={'30px'} />
      </Link>
    </Flex>
  );
});
